export default class NavLink extends HTMLElement {
  constructor() {
    super();

    if (!this.linkEl || !this.linkPath || this.linkHasAriaCurrent) return;

    if (this.linkIsCurrent) {
      this.linkEl.setAttribute("aria-current", "page");
    } else if (this.ancestorIsCurrent) {
      this.linkEl.classList.add("is-current");
    }
  }

  get linkEl() {
    return this.querySelector("a");
  }

  get linkHasAriaCurrent() {
    const ariaCurrent = this.linkEl.getAttribute("aria-current");
    return ariaCurrent === "page";
  }

  get linkPath() {
    if (!this.linkEl.href) return null;
    const url = new URL(this.linkEl.href);
    return url.pathname;
  }

  get currentPath() {
    const url = new URL(window.location);
    return url.pathname;
  }

  get linkIsCurrent() {
    return this.linkPath === this.currentPath;
  }

  get linkPathIsCatalog() {
    return this.linkPath === "/collections/catalog";
  }

  get linkPathIsBookClub() {
    return this.linkPath === "/pages/book-club";
  }

  get currentPathIsBookProduct() {
    return (
      this.currentPath.startsWith("/products/") &&
      !this.currentPath.startsWith("/products/book-club-") &&
      !this.currentPath.startsWith("/products/verso-gift-card")
    );
  }

  get currentPathIsBookClubProduct() {
    return this.currentPath.startsWith("/products/book-club-");
  }

  // not pretty but actual ancestor by pathname doesn't really align with
  // what the user-facing "ancestor" nav item would be. for instance,
  // when viewing a book product (/products/1234-some-book) we want to highlight
  // "Books" in the nav (/collections/catalog). Book Club pages and gift cards need
  // extra logic to avoid duplicate active nav items. Ideally this logic wouldn't be
  // hard-coded like this but the primary nav does not change often.
  get ancestorIsCurrent() {
    if (this.currentPath.startsWith(this.linkPath)) return true;
    if (this.linkPathIsCatalog && this.currentPathIsBookProduct) return true;
    if (this.linkPathIsBookClub && this.currentPathIsBookClubProduct)
      return true;
    return false;
  }

  isProductOrCollection(pathname) {
    return (
      pathname.startsWith("/products/") || pathname.startsWith("/collections/")
    );
  }
}
